// Translation for cs
export const cs = {
        common: {
            save: 'Uložit',
            cancel: 'Zrušit',
            close: 'Zavřít',
            delete: 'Smazat',
            edit: 'Upravit',
            activate: 'Aktivovat',
            add: 'Přidat',
            saving: 'Ukládám...',
            loading: 'Načítám...',
            active: 'AKTIVNÍ',
            inUse: 'Používáno',
            test: 'Test',
            searchApps: 'Hledat aplikace...',
            betaBanner: 'BETA - Služba není ještě dostupná!'
        },
        header: {
            creditBalance: 'Zůstatek',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Přihlášení',
            signUp: 'Registrace',
            username: 'Uživatelské jméno',
            password: 'Heslo',
            continue: 'Pokračovat',
            noAccount: 'Nemáš účet?',
            hasAccount: 'Už máš účet?',
            loginError: 'Přihlášení se nezdařilo',
            invalidCredentials: 'Neplatné uživatelské jméno nebo heslo',
            rateLimited: 'Příliš mnoho pokusů o přihlášení. Čekej chvíli.',
            sessionExpired: 'Tvá relace vypršela. Použij nový kouzelný odkaz.',
            magicLinkInvalid: 'Odkaz pro přihlášení je neplatný nebo vypršel.',
            magicLinkSuccess: 'Vítej! Byl jsi úspěšně přihlášen.',
            magicLinkProcessing: 'Zpracovávám přihlášení...',
            connectionError: 'Chyba připojení. Zkus to znovu.'
        },
        profile: {
            myProgress: 'Můj Pokrok Učení',
            signOut: 'Odhlášení',
            plan: 'Plán: '
        },
        settings: {
            title: 'Nastavení',
            tabs: {
                uiSettings: 'Nastavení UI',
                systemPrompt: 'Systémový Prompt',
                llmProfiles: 'Profily LLM',
                ttsProfiles: 'Profily TTS',
                language: 'Jazyk',
            },
            uiSettings: {
                title: 'Uživatelské Rozhraní',
                themeMode: 'Režim Motivu',
                darkMode: 'Tmavý Režim',
                lightMode: 'Světlý Režim',
                themeColor: 'Barva Motivu',
                themeColorDesc: 'Vyber barvu zvýraznění pro tlačítka, ikony a zvýraznění',
                background: 'Pozadí',
                backgroundDesc: 'Vyber pozadí pro svůj pracovní prostor',
                selectBackgroundColor: 'Vyber Barvu Pozadí',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Zaměření',
                    concentration: 'Soustředění',
                    relaxation: 'Relaxace',
                    lianas: 'Liány',
                    color: 'Barva'
                },
                backgroundColors: {
                    deepDark: 'Hluboké Černé',
                    darkGrey: 'Tmavě Šedá',
                    midnightBlue: 'Půlnoční Modrá',
                    indigo: 'Indigo',
                    darkTeal: 'Tmavě Modrozelená',
                    brown: 'Hnědá',
                    darkRed: 'Tmavě Červená',
                    deepPurple: 'Hluboce Fialová',
                    pureWhite: 'Čistě Bílá',
                    softWhite: 'Měkce Bílá',
                    lightGrey: 'Světle Šedá',
                    paleBlue: 'Bledě Modrá',
                    paleGreen: 'Bledě Zelená',
                    paleOrange: 'Bledě Oranžová',
                    lavender: 'Levandule',
                    blueGrey: 'Modrobílá'
                }
            },
            systemPrompt: {
                label: 'Systémový Prompt:',
                placeholder: 'Načítám systémový prompt...',
                emptyError: 'Systémový prompt nemůže být prázdný!',
                saveSuccess: '✓ Systémový prompt byl úspěšně uložen!',
                loadError: 'Chyba při načítání systémového promptu',
                saveError: 'Chyba při ukládání'
            },
            llmProfiles: {
                addButton: '+ Přidat Nové Připojení',
                newConnection: 'Nové Připojení',
                editConnection: 'Upravit Připojení',
                emptyState: 'Nejsou dostupná připojení LLM. Klikni níže pro přidání jednoho.',
                loadingProfiles: 'Načítám profily...',
                nameLabel: 'Název *',
                namePlaceholder: 'např. OpenAI GPT-4',
                apiUrlLabel: 'URL API *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'Klíč API *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Model *',
                modelPlaceholder: 'gpt-4, mistral-tiny, atd.',
                allFieldsRequired: 'Všechna pole musí být vyplněna!',
                saveSuccess: '✓ Profil byl úspěšně uložen!',
                deleteConfirm: 'Opravdu chceš smazat "{name}"?',
                profileNotFound: 'Profil nebyl nalezen!',
                loadError: 'Chyba při načítání profilů',
                saveError: 'Chyba při ukládání',
                activateError: 'Chyba při aktivaci',
                deleteError: 'Chyba při mazání',
                modelInfo: 'Model: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Přidat Nový Hlas',
                newVoice: 'Nový Hlas',
                editVoice: 'Upravit Hlas',
                emptyState: 'Nejsou dostupné profily TTS. Klikni níže pro přidání jednoho.',
                loadingProfiles: 'Načítám profily TTS...',
                nameLabel: 'Název',
                namePlaceholder: 'např. Můj ElevenLabs Adam',
                providerLabel: 'Poskytovatel',
                providerPlaceholder: 'např. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Místní)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'URL API *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'Klíč API *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'ID Modelu *',
                modelIdPlaceholder: 'např. eleven_monolingual_v1',
                voiceIdLabel: 'ID Hlasu',
                voiceIdPlaceholder: 'např. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Všechna pole musí být vyplněna!',
                saveSuccess: '✓ Profil TTS byl úspěšně uložen!',
                deleteConfirm: 'Opravdu chceš smazat "{name}"?',
                loadError: 'Chyba při načítání profilů TTS',
                saveError: 'Chyba při ukládání',
                activateError: 'Chyba při aktivaci',
                deleteError: 'Chyba při mazání'
            },
            language: {
                title: 'Vyber Jazyk',
                description: 'Vyber preferovaný jazyk pro uživatelské rozhraní'
            },
        },
        chat: {
            ready: 'Připraven',
            start: 'START',
            stop: 'STOP',
            initialMessage: 'Klikni START pro konverzaci v reálném čase.',
            listening: 'Poslouchám...',
            speaking: 'Thorsten mluví...',
            userLabel: 'Ty',
            aiLabel: 'AI',
            modalTitle: 'Chat AI Thorsten',
            inputPlaceholder: 'Napiš zprávu...',
            send: 'Poslat',
            loginRequired: 'Přihlaš se pro použití této služby.',
            loginButton: 'Přihlaš se Nyní',
            magicLinkRequired: 'Použij kouzelný odkaz pro přihlášení.',
            creditLimitError: 'Tvá hodinová kvóta byla vyčerpána. Upgraduj svůj plán (Medium/Premium) pro pokračování.',
            serviceDisabled: 'Chatová služba je momentálně nedostupná. Zkuste to prosím později.'
        },
        notifications: {
            error: 'Chyba',
            success: 'Úspěch',
            info: 'Informace',
            unknownError: 'Došlo k neznámé chybě'
        },
        cookie: {
            message: 'Tato webová stránka používá cookies pro poskytnutí nejlepšího uživatelského zážitku.',
            accept: 'Přijmout'
        },
        curriculum: {
                buttonLabel: 'Učební plán',
                buttonTitle: 'Zobrazit obsah učebního plánu',
                modalTitle: 'Učební plán {app}',
                sections: {
                    topic: 'Téma učebního plánu',
                    explanation: 'Vysvětlení pro děti',
                    studentProfile: 'Profil studenta'
                },
                topic: {
                    empty: 'K této mikroaplikaci není v backendu přiřazeno žádné téma učebního plánu.',
                    missingDetail: 'Podrobná data učebního plánu pro tuto mikroaplikaci zatím nejsou v backendu k dispozici.',
                    learningGoals: 'Cíle učení',
                    prerequisites: 'Předpoklady',
                    unitLabel: 'Jednotka',
                    durationLabel: 'Délka',
                    difficultyLabel: 'Obtížnost',
                    hours: 'hod',
                    minutes: 'min'
                },
                explanation: {
                    empty: 'Žádné vysvětlení pro děti není k dispozici.',
                    loadingPrepare: 'AI připravuje vysvětlení',
                    loadingExplain: 'AI vysvětluje téma jazykem srozumitelným pro děti',
                    requestFailed: 'Vysvětlení pro děti se nepodařilo vygenerovat.'
                },
                studentProfile: {
                    country: 'Země',
                    region: 'Stát / Region',
                    schoolType: 'Typ školy',
                    grade: 'Ročník',
                    noContext: 'Kontext studenta není k dispozici.',
                    childProfileNotFound: 'Pro aktuální přihlášení nebyl v backendu nalezen žádný profil studenta.',
                    loginProfileIncomplete: 'Přihlašovací profil zatím neobsahuje úplný kontext studenta.',
                    educationContextNotFound: 'Profil studenta byl nalezen, ale není nastaveno žádné přiřazení učebního plánu.',
                    noToken: 'Nebyl nalezen žádný přihlášený student.'
                },
                errors: {
                    signInRequired: 'Pro zobrazení učebního plánu se prosím přihlaste.',
                    appIdMissing: 'Chybí ID aplikace.',
                    loadFailed: 'Nepodařilo se načíst data učebního plánu.'
                }
            }
    };
